import { memo } from "react";
import { connect } from "react-redux";

import { reducer, mapStateToProps, mapDispatchToProps } from "./DatePicker.state";
import DatePicker from "./DatePicker";

export default memo(connect(mapStateToProps, mapDispatchToProps)(DatePicker));

export { reducer, mapStateToProps, mapDispatchToProps };
